import * as React from 'react';
import { MetroIcon } from '@cian/ui-kit/prev';
import classNames from 'classnames';

import { ETransportType } from '../../../types/geo';
import { UndergroundTimeToGet } from './UndergroundTimeToGet';

import * as styles from './styles.css';

export interface IUndergroundProps {
  name: string;
  transportType?: ETransportType | null;
  time?: number | null;
  lineColor?: string | null;
  underConstruction: boolean;
}

export function Underground({ lineColor, name, transportType, time, underConstruction }: IUndergroundProps) {
  return (
    <div className={classNames(styles['container'], underConstruction && styles['under-construction'])}>
      {lineColor && (
        <div className={styles['icon']} style={{ color: `#${lineColor}` }}>
          <MetroIcon custom={{ size: '14' }} styles={{ color: 'currentColor' }} />
        </div>
      )}
      <span>{name}</span>

      {time && transportType && <UndergroundTimeToGet time={time} transportType={transportType} />}
    </div>
  );
}
